import React, { FC } from 'react';
// import Pagination from '@material-ui/lab/Pagination';

import { formatDate } from 'utils/date';
import Placeholder from 'components/Placeholders/Comment';
import Comment from 'components/Comment';
import CommentLoader from 'components/Loaders/Comment';
import SmallAreaLoader from 'components/Loaders/SmallAreaChart';
import RatingsLoader from 'components/Loaders/RatingsLoader';
import MultipleAreaChart from 'components/Charts/MultipleAreaChart';
import useConnect from './connect';
import { Props } from './types';

import {
  Container,
  Grid,
  Section,
  Title,
  Row,
  Name,
  Sales,
  Percentage,
  Number,
  ArrowDownIcon,
  ArrowUpIcon,
  Rating,
  RatingCard,
  CommentsCard,
  // Header,
  // DateCaption,
  // DatesSelector,
  // PaginationContainer,
} from './styles';

const Quality: FC<Props> = ({ brandId }) => {
  const {
    quality,
    isLoading,
    // nextCommentPage,
    // hoverRange,
    // selectedDays,
    // handleDayChange,
    // handleDayEnter,
    // handleDayLeave,
    // handleWeekClick,
  } = useConnect(brandId);

  return (
    <Container>
      {/* <Header>
        <DateCaption>Date range</DateCaption> */}
      {/* TODO: TFR-27. replace with real, not mocked data */}
      {/* <DatesSelector
          hoverRange={hoverRange}
          selectedDays={selectedDays}
          handleDayChange={handleDayChange}
          handleDayEnter={handleDayEnter}
          handleDayLeave={handleDayLeave}
          handleWeekClick={handleWeekClick}
        />
      </Header> */}
      <Grid>
        <Section>
          <Title>Ratings</Title>
          <RatingCard>
            {!quality || isLoading ? (
              <>
                <RatingsLoader opacity={1} />
                <RatingsLoader opacity={0.75} />
                <RatingsLoader opacity={0.5} />
                <RatingsLoader opacity={0.25} />
                <RatingsLoader opacity={0} />
              </>
            ) : (
              quality.ratings.map((brand) => (
                <Row key={brand.integration}>
                  <Name>{brand.integration}</Name>
                  <Sales>{brand.count}</Sales>
                  <Percentage trend={brand.change > 1}>
                    {brand.change > 1 ? <ArrowUpIcon /> : <ArrowDownIcon />}
                    <Number>{Math.abs(brand.change)} %</Number>
                  </Percentage>
                  <Rating> {brand.stars}</Rating>
                </Row>
              ))
            )}
          </RatingCard>
        </Section>

        <Section>
          <Title>Historical rating</Title>
          {!quality || isLoading ? (
            <SmallAreaLoader />
          ) : (
            <MultipleAreaChart
              hasLegend
              yAxisTooltipName="Rating"
              colors={['#AEADAE', '#F3E7DE', '#228B22', '#000000', '#EF5347']}
              names={['w', 'e', 'r', 't', 'u']}
              data={[
                {
                  xAxis: '10/12/2021',
                  y: 15457,
                  w: 16000,
                  e: 15000,
                  r: 17000,
                  t: 14000,
                  u: 12000,
                  launcher: 'Nick',
                },
                {
                  xAxis: '11/12/2021',
                  y: 12457,
                  w: 17000,
                  e: 12000,
                  r: 14000,
                  t: 16000,
                  u: 18000,
                  launcher: 'Nick',
                },
                {
                  xAxis: '12/12/2021',
                  y: 19457,
                  w: 12000,
                  e: 16000,
                  r: 18000,
                  t: 11000,
                  u: 15000,
                  launcher: 'Nick',
                },
              ]}
            />
          )}
        </Section>
      </Grid>
      <Section>
        <Title>Comments</Title>
        <CommentsCard>
          {(() => {
            if (!quality || isLoading) {
              return (
                <>
                  <CommentLoader opacity={0.5} />
                  <CommentLoader opacity={0.25} />
                  <CommentLoader opacity={0} />
                </>
              );
            }

            if (quality.comments.length !== 0) {
              return (
                <div>
                  {quality.comments.map((brand) => (
                    <Comment
                      key={brand.orderId}
                      name={brand.name}
                      date={formatDate(brand.date, 'MM/dd/yyyy')}
                      comment={brand.commentText}
                      rating={brand.rating}
                      order={brand.integration}
                    />
                  ))}
                  {/* <PaginationContainer>
                    <Pagination
                      count={10}
                      variant="outlined"
                      shape="rounded"
                      onChange={nextCommentPage}
                    />
                  </PaginationContainer> */}
                </div>
              );
            }
            return <Placeholder />;
          })()}
        </CommentsCard>
      </Section>
    </Container>
  );
};

export default Quality;
